import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useState } from "react";

export const useGetAllCardsService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  //Hooks
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allCardsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CARDS,
      page,
      per_page,
      created_between,
      debouncedQuery,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CARDS,
        searchParams: {
          page,
          per_page,
          "filter[title]": debouncedQuery,
          "filter[created_between]": created_between,
          include: "card_type",
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allCardsService },
    state: { searchQuery, setSearchQuery },
  };
};
